import React, { useEffect, useState } from 'react';
import { Item, ListContainer, Title, TitleWrap, Subtitle } from './style';
import cancelaIcon from "../../assets/icons/icon-trash-red.png"
import InputV3 from '../input/novo/input_v3';
import api from '../../services/api';
import { store } from "react-notifications-component";

import identifyErrorMenssage from "../../services/identifyErrorMenssage";
const List = ({ ...props }) => {

    const [values, setValues] = useState([]);
    const [headerText, setHeadertext] = useState('');
    const [valueText, setValueText] = useState('');

    const changeHeader = (value) => {
        setHeadertext(value);
    }

    const changeValue = (value) => {
        setValueText(value);
    }

    const blur = () => {
        if (headerText !== '' && valueText !== '') {
            props.onChange({
                header: headerText,
                value: valueText
            });
        }
    }

    const onDelete = async (id, index) => {
        try {

            if (id) {
                const response = await api.delete(`/integracao/inativar/${id}`);
                if (response) {

                    let hd = values;
                    let head = [];

                    hd.map((h, i) => {
                        if (h.header_id !== id && i !== index) {
                            head = [...head, h];
                        }
                    });

                    setValues(head);

                    store.addNotification({
                        title: "Sucesso!",
                        message: `Excluido com sucesso!`,
                        type: "success",
                        insert: "top",
                        container: "top-right",
                        animationIn: ["animated", "fadeIn"],
                        animationOut: ["animated", "fadeOut"],
                        dismiss: {
                            duration: 4000,
                            onScreen: true
                        }
                    });
                }
            } else {
                let hd = values;
                let head = [];

                hd.map((h, i) => {
                    if (i !== index) {
                        head = [...head, h];
                    }
                });

                setValues(head);

            }
        } catch (error) {
            store.addNotification({
                title: "Erro!",
                message: identifyErrorMenssage(error),
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 4000,
                    onScreen: true
                }
            });
        }
    }
    useEffect(() => {
        setValues(props.values);

        setHeadertext('');
        setValueText('');

    }, [props.values]);

    return (
        <ListContainer>

            <TitleWrap>
                <Title>Headers</Title>
                <Subtitle>Opcional: adicione informações extras que seu sistema espera receber junto com o aviso.</Subtitle>
            </TitleWrap>

            {values.map((i, index) => (
                <Item key={i.header_id || index}>
                    <InputV3 floatingLabel="Header" value={i.header} isDisabled />
                    <InputV3 floatingLabel="Value" value={i.value} isDisabled />
                    <img onClick={() => onDelete(i.header_id, index)} src={cancelaIcon} width="16px" alt="Excluir" />
                </Item>
            ))}

            <Item>
                <InputV3
                    id={`setheader-${props.id}`}
                    floatingLabel="Add header"
                    value={headerText}
                    onChange={(e) => changeHeader(e.target.value)}
                    onBlur={() => blur()}
                />

                <InputV3
                    id={`setvalue-${props.id}`}
                    floatingLabel="Add value"
                    value={valueText}
                    onChange={(e) => changeValue(e.target.value)}
                    onBlur={() => blur()}
                />
            </Item>
        </ListContainer>
    )
}

export default List;
